import { BaseContainer } from './BaseContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseSvg = ({
  children,
  name,
  size
}) => {
  return /*#__PURE__*/_jsx(BaseContainer, {
    $svgSize: size,
    children: /*#__PURE__*/_jsx("svg", {
      viewBox: "0 0 216 216",
      focusable: "false",
      xmlns: "http://www.w3.org/2000/svg",
      "data-svg-name": name,
      "data-test-id": "AvatarDisplay-svgIcon",
      children: children
    })
  });
};